import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

function SecondaryLanguageText({ secondaryLanguage }) {
    return <span>{secondaryLanguage}</span>;
}

SecondaryLanguageText.propTypes = {
    secondaryLanguage: PropTypes.string,
};

export default connect(({ commonI18Dashboard: { LANGUAGES, secondaryLanguage } }) => ({
    secondaryLanguage: LANGUAGES[secondaryLanguage],
}))(SecondaryLanguageText);



/** WEBPACK FOOTER **
 ** ../src/dash/front/common-i18-dashboard-page/components/SecondaryLanguageText.js
 **/